import React, { useEffect, useMemo, useState } from "react";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const Dropdown = (props) => {
  const SelectDropdown = props?.creatable ? CreatableSelect : Select;
  const [options, setOptions] = useState(props?.options);
  const [inputValue, setInputValue] = useState("");
  const dropdownStyles = {
    container: (styles) => ({
      ...styles,
      zIndex: 2,
    }),
    control: (styles, { isDisabled }) => ({
      ...styles,
      backgroundColor: isDisabled ? "#D2D6DB80" : "white",
      paddingLeft: "0.3rem",
      borderRadius: "0.375rem",
    }),
    option: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
      };
    },
    input: (styles) => ({
      ...styles,
      height: "35px",
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: "0.875rem",
    }),
    singleValue: (styles) => ({
      ...styles,
      fontSize: "0.875rem",
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
      paddingRight: "0.3rem",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      "& svg": {
        color: "#6C737F",
      },
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 999,
    }),
  };

  const selectedValue = useMemo(() => {
    if (props?.selectedValue) {
      const _selectedValue = options?.find(
        (option) =>
          JSON.stringify(option?.value) === JSON.stringify(props?.selectedValue)
      );
      return _selectedValue;
    }
    return null;
  }, [options, props?.selectedValue]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    if (props.onInputChange) {
      props.onInputChange(newValue);
    }
  };
  const handleChange = (selectedOption) => {
    if (selectedOption === null) {
      setInputValue("");
    }
    if (props.onChange) {
      props.onChange(selectedOption);
    }
  };

  const onCreateOption = (inputValue) => {
    if (
      inputValue &&
      typeof inputValue == "string" &&
      inputValue?.length &&
      inputValue?.trimStart()
    ) {
      const newOption = {
        value: inputValue.trimStart(),
        label: inputValue.trimStart(),
      };
      setOptions([...options, newOption]);
      handleChange(newOption);
    }
  };

  useEffect(() => {
    setOptions(props?.options);
  }, [JSON.stringify(props?.options)]);

  return (
    <SelectDropdown
      styles={dropdownStyles}
      classNamePrefix="react-select"
      placeholder="-Select-"
      value={selectedValue}
      name={props.selectedName}
      onInputChange={handleInputChange}
      onChange={handleChange}
      isClearable
      {...props}
      options={options}
      onCreateOption={onCreateOption}
      menuPlacement="auto"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#8b58f1",
          primary75: "#8b58f1",
          primary50: "#8b58f11a",
          primary25: "#8b58f11a",
        },
      })}
    />
  );
};

export default Dropdown;
